import script from "./DefaultMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultMessage.vue?vue&type=script&setup=true&lang=js"

import "./DefaultMessage.vue?vue&type=style&index=0&id=12975d0c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12975d0c"]])

export default __exports__